export const almoxarifadoRoute: string = 'almoxarifado';
export const almoxarifadoModuleName: any = {plural: 'Almoxarifados', single: 'Almoxarifado'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/shared/data.service.ts
 **/